import { useState } from "react";
import { mealTypeLabels } from "../../application/meal-detection";
import { type ParsedVoiceMealDraft } from "../../application/remote-meal-parser";
import type { MealType } from "../../domain/model";

export function useDaySummary(repository: import("../../application/meal-repository").MealRepository, selectedDate: string) {
  const [daySummaryOpen, setDaySummaryOpen] = useState(false);
  const [daySummaryLoading, setDaySummaryLoading] = useState(false);
  const [daySummaryDrafts, setDaySummaryDrafts] = useState<ParsedVoiceMealDraft[]>([]);
  const openDaySummary = async () => {
    setDaySummaryOpen(true);
    setDaySummaryLoading(true);
    try {
      const drafts = await Promise.all((Object.keys(mealTypeLabels) as MealType[]).map(meal => repository.getDraft(selectedDate, meal)));
      setDaySummaryDrafts(drafts.filter((draft): draft is ParsedVoiceMealDraft => draft !== null));
    } catch {
      setDaySummaryDrafts([]);
    } finally {
      setDaySummaryLoading(false);
    }
  };

  return { daySummaryOpen, setDaySummaryOpen, daySummaryLoading, daySummaryDrafts, openDaySummary };
}
